import { render, staticRenderFns } from "./Growth.vue?vue&type=template&id=d4a62a78&scoped=true&"
import script from "./Growth.vue?vue&type=script&lang=js&"
export * from "./Growth.vue?vue&type=script&lang=js&"
import style0 from "./Growth.vue?vue&type=style&index=0&id=d4a62a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a62a78",
  null
  
)

export default component.exports